export const DEASP_LABEL = "DEASP eCert";

// The DEASP eCert entry is seeded as a `DEASP_CERT` document type, but its
// documents are never populated. DEASP certificates are read via the
// patient-scoped healthlink deasp-form endpoint instead, so the patient
// Documents menu swaps this entry for the DeaspTable and the global Documents
// page (which has no all-patients DEASP endpoint) hides it entirely.
export const isDeaspDocumentType = (documentType) =>
  documentType?.name?.toUpperCase() === "DEASP_CERT" ||
  documentType?.label === DEASP_LABEL;
